import styled from 'styled-components';

import { ProductBreadcrumbs } from 'productTemplate/components/footer/ProductBreadcrumbs';
import { variableFont, variableFontRegular } from 'styles/theme';

interface IProductInfo {
  name: string;
  releaseDate: string;
  releaseYear: string;
}

export const ProductInfo = ({ name, releaseDate, releaseYear }: IProductInfo) => {
  const year = releaseYear || new Date(releaseDate).getFullYear() || '';

  return (
    <ProductInfo.Wrapper data-qa="product_info_wrapper">
      <div>
        <div className="productTitle">
          {year && <h2 data-qa="product_year">{year}</h2>}
          <div>
            <h1 data-qa="product_name" className="productName">
              {name}
            </h1>
            <ProductBreadcrumbs />
          </div>
        </div>
      </div>
    </ProductInfo.Wrapper>
  );
};

ProductInfo.Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  ${variableFontRegular({ size: '11px' })};

  .productTitle {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: baseline;
    gap: 12px;

    > div {
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    .productName {
      max-width: 50%;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.small}px) {
    .productName {
      max-width: 190px;
    }
  }

  h1,
  h2 {
    @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
      ${variableFont({ fontWeight: '400', height: '14px', size: '11.5px' })};
      margin: 0;
      padding-bottom: 4px;
    }
  }

  ol {
    ${variableFontRegular({ size: '11px' })};
  }
`;
